import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';

import classes from './Confirmation.css' // webpack must be configured to do this
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';

import { beautifyLocalTimeFromTimestamp, backendEndpoint } from '../../../store/utility';
import * as actions from '../../../store/actions/index';

class Confirmation extends React.Component {

    constructor(props){
        super(props);
        this.signupPasswordInput = React.createRef(); 
        this.state = {
            signupInProgress: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleGoHome() {
        window.location.href="/home";
    }

    handleCreateMyPage = () => {
        if (this.props.isAuthenticated===false) {
            let pwd = this.signupPasswordInput.current.value;
            this.props.onSignup(
                this.props.lastBookedAppointment.email, 
                pwd, 
                true, 
                pwd, 
                this.props.lastBookedAppointment.first_name, 
                this.props.lastBookedAppointment.last_name
            )
            this.setState({signupInProgress: true})
        }
        else {
            window.location.href="/profile";
        }
    }

    handleAddToCalendar = () => {
        let url = backendEndpoint + "appointment/" + this.props.lastBookedAppointment.id + "/calendar_invite/";
        const response = {
            file: url,
        };
        window.open(response.file);
    }

    render() {

        // sign up redirect
        let signupRedirect;
        if ( (this.state.signupInProgress===true) && (this.props.isAuthenticated===true) ) {
            signupRedirect = <Redirect to={this.props.authRedirectPath}/>
        }

        // rendering booking confirmation page
        let time = this.props.lastBookedAppointment ? beautifyLocalTimeFromTimestamp(this.props.lastBookedAppointment.due_date) : <Spinner animation="border" variant="info" />;
        let displaySize = "none";
        if (this.props.isMobile===true) {
            displaySize = 'none';
        }

        let question_text;
        let reject_option;
        if (this.props.isAuthenticated===true) {
            question_text = "Manage my appointments now?"
            reject_option = (<Button variant="outline-info" size={displaySize} onClick={this.handleGoHome}>No</Button>);
        }
        else {
            question_text = (
                <div>
                    <Row>
                    {/* <Col>Sign up to manage your appointments?</Col> */}
                    <Col>Creat an account <div><span>to manage your appointments</span></div></Col>
                    </Row>
                    <Row>
                    <Col>
                    <div className={classes.QuestionInput}>
                        <Form.Control type="password" placeholder="Enter New Password" ref={this.signupPasswordInput}/>
                    </div>
                    </Col>
                    </Row>
                </div>
            )
            reject_option = (<a onClick={this.handleGoHome}>No, I will sign up later.</a>);
        }

        let confirmationBlock;
        if (this.props.lastBookedAppointment) {
            confirmationBlock = (
                <div>
                <div className={classes.Confirmation}>
                <Container>
                <Row>
                    <Col>
                        <p><b>Congratulations!</b></p>
                        <p>You just booked a call with <b>{this.props.calendarOwnerFirstName}</b></p>
                        <p>@ <b>{time}</b></p>
                        {/* <p>A confirmation email with the <b>Calendar Invite</b> has been sent to your email. If email ends up in junk, please move it back to inbox so reminder emails can be received.</p> */}
                        <p>At the appointment time, your host {this.props.calendarOwnerFirstName} will reach out to you with your prefered contact methods.</p>
                        {/* <Button variant="outline-info" size={displaySize} onClick={this.handleAddToCalendar}>Add to Calendar</Button> */ }
                    </Col>
                </Row>
    
                </Container>
                </div>
                    <div className={classes.Conversion}>
                    <Container>
        
                        <Row className={classes.ConversionQuestion}>
                            <Col>
                                { question_text }
                            </Col>
                        </Row>
        
                        <Row className={classes.Accept}>
                            <Col>
                            { this.props.loading===true ? <Spinner animation="border" variant="info" /> : 
                            <Button variant="info" size={displaySize} onClick={this.handleCreateMyPage}>Yes</Button>
                            }
                            </Col>
                        </Row>
        
                        <Row className={classes.Reject}>
                            <Col>
                                { reject_option }
                            </Col>
                        </Row>
        
                    </Container>
                </div>
                </div>
            )
        }

        else {
            confirmationBlock = (
                <div className={classes.Confirmation}>
                <Container>
                <Row>
                    <Col>
                    <Spinner animation="border" variant="info" /> ... confirming your booking ... 
                    </Col>
                </Row>
    
                </Container>
                </div>
            )
        }

        return (
            <div>
            { signupRedirect }
            { confirmationBlock }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        lastBookedAppointment: state.schedule.last_booked_appointment,
        authRedirectPath: state.auth.authRedirectPath,
        loading: state.auth.loading,
        error: state.auth.error,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSignup: ( email, password, isSignup, password_confirm, first_name, last_name ) => dispatch( actions.auth( email, password, isSignup, password_confirm, first_name, last_name ) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (Confirmation);


// WEBPACK FOOTER //
// ./src/containers/Schedule/Confirmation/Confirmation.js